"use strict";

export var LANGUAGE_BY_LOCALE = [{
  id: "af-NA",
  name: "Afrikaans (Namibia)"
}, {
  id: "af-ZA",
  name: "Afrikaans (South Africa)"
}, {
  id: "af",
  name: "Afrikaans"
}, {
  id: "ak-GH",
  name: "Akan (Ghana)"
}, {
  id: "ak",
  name: "Akan"
}, {
  id: "sq-AL",
  name: "Albanian (Albania)"
}, {
  id: "sq",
  name: "Albanian"
}, {
  id: "am-ET",
  name: "Amharic (Ethiopia)"
}, {
  id: "am",
  name: "Amharic"
}, {
  id: "ar-DZ",
  name: "Arabic (Algeria)"
}, {
  id: "ar-BH",
  name: "Arabic (Bahrain)"
}, {
  id: "ar-EG",
  name: "Arabic (Egypt)"
}, {
  id: "ar-IQ",
  name: "Arabic (Iraq)"
}, {
  id: "ar-JO",
  name: "Arabic (Jordan)"
}, {
  id: "ar-KW",
  name: "Arabic (Kuwait)"
}, {
  id: "ar-LB",
  name: "Arabic (Lebanon)"
}, {
  id: "ar-LY",
  name: "Arabic (Libya)"
}, {
  id: "ar-MA",
  name: "Arabic (Morocco)"
}, {
  id: "ar-OM",
  name: "Arabic (Oman)"
}, {
  id: "ar-QA",
  name: "Arabic (Qatar)"
}, {
  id: "ar-SA",
  name: "Arabic (Saudi Arabia)"
}, {
  id: "ar-SD",
  name: "Arabic (Sudan)"
}, {
  id: "ar-SY",
  name: "Arabic (Syria)"
}, {
  id: "ar-TN",
  name: "Arabic (Tunisia)"
}, {
  id: "ar-AE",
  name: "Arabic (United Arab Emirates)"
}, {
  id: "ar-YE",
  name: "Arabic (Yemen)"
}, {
  id: "ar",
  name: "Arabic"
}, {
  id: "hy-AM",
  name: "Armenian (Armenia)"
}, {
  id: "hy",
  name: "Armenian"
}, {
  id: "as-IN",
  name: "Assamese (India)"
}, {
  id: "as",
  name: "Assamese"
}, {
  id: "asa-TZ",
  name: "Asu (Tanzania)"
}, {
  id: "asa",
  name: "Asu"
}, {
  id: "az-Cyrl",
  name: "Azerbaijani (Cyrillic)"
}, {
  id: "az-Cyrl-AZ",
  name: "Azerbaijani (Cyrillic, Azerbaijan)"
}, {
  id: "az-Latn",
  name: "Azerbaijani (Latin)"
}, {
  id: "az-Latn-AZ",
  name: "Azerbaijani (Latin, Azerbaijan)"
}, {
  id: "az",
  name: "Azerbaijani"
}, {
  id: "bm-ML",
  name: "Bambara (Mali)"
}, {
  id: "bm",
  name: "Bambara"
}, {
  id: "eu-ES",
  name: "Basque (Spain)"
}, {
  id: "eu",
  name: "Basque"
}, {
  id: "be-BY",
  name: "Belarusian (Belarus)"
}, {
  id: "be",
  name: "Belarusian"
}, {
  id: "bem-ZM",
  name: "Bemba (Zambia)"
}, {
  id: "bem",
  name: "Bemba"
}, {
  id: "bez-TZ",
  name: "Bena (Tanzania)"
}, {
  id: "bez",
  name: "Bena"
}, {
  id: "bn-BD",
  name: "Bengali (Bangladesh)"
}, {
  id: "bn-IN",
  name: "Bengali (India)"
}, {
  id: "bn",
  name: "Bengali"
}, {
  id: "bs-BA",
  name: "Bosnian (Bosnia and Herzegovina)"
}, {
  id: "bs",
  name: "Bosnian"
}, {
  id: "bg-BG",
  name: "Bulgarian (Bulgaria)"
}, {
  id: "bg",
  name: "Bulgarian"
}, {
  id: "my-MM",
  name: "Burmese (Myanmar [Burma])"
}, {
  id: "my",
  name: "Burmese"
}, {
  id: "ca-ES",
  name: "Catalan (Spain)"
}, {
  id: "ca",
  name: "Catalan"
}, {
  id: "tzm-Latn",
  name: "Central Morocco Tamazight (Latin)"
}, {
  id: "tzm-Latn-MA",
  name: "Central Morocco Tamazight (Latin, Morocco)"
}, {
  id: "tzm",
  name: "Central Morocco Tamazight"
}, {
  id: "chr-US",
  name: "Cherokee (United States)"
}, {
  id: "chr",
  name: "Cherokee"
}, {
  id: "cgg-UG",
  name: "Chiga (Uganda)"
}, {
  id: "cgg",
  name: "Chiga"
}, {
  id: "zh-Hans",
  name: "Chinese (Simplified Han)"
}, {
  id: "zh-Hans-CN",
  name: "Chinese (Simplified Han, China)"
}, {
  id: "zh-Hans-HK",
  name: "Chinese (Simplified Han, Hong Kong SAR China)"
}, {
  id: "zh-Hans-MO",
  name: "Chinese (Simplified Han, Macau SAR China)"
}, {
  id: "zh-Hans-SG",
  name: "Chinese (Simplified Han, Singapore)"
}, {
  id: "zh-Hant",
  name: "Chinese (Traditional Han)"
}, {
  id: "zh-Hant-HK",
  name: "Chinese (Traditional Han, Hong Kong SAR China)"
}, {
  id: "zh-Hant-MO",
  name: "Chinese (Traditional Han, Macau SAR China)"
}, {
  id: "zh-Hant-TW",
  name: "Chinese (Traditional Han, Taiwan)"
}, {
  id: "zh",
  name: "Chinese"
}, {
  id: "kw-GB",
  name: "Cornish (United Kingdom)"
}, {
  id: "kw",
  name: "Cornish"
}, {
  id: "hr-HR",
  name: "Croatian (Croatia)"
}, {
  id: "hr",
  name: "Croatian"
}, {
  id: "cs-CZ",
  name: "Czech (Czech Republic)"
}, {
  id: "cs",
  name: "Czech"
}, {
  id: "da-DK",
  name: "Danish (Denmark)"
}, {
  id: "da",
  name: "Danish"
}, {
  id: "nl-BE",
  name: "Dutch (Belgium)"
}, {
  id: "nl-NL",
  name: "Dutch (Netherlands)"
}, {
  id: "nl",
  name: "Dutch"
}, {
  id: "ebu-KE",
  name: "Embu (Kenya)"
}, {
  id: "ebu",
  name: "Embu"
}, {
  id: "en-AS",
  name: "English (American Samoa)"
}, {
  id: "en-AU",
  name: "English (Australia)"
}, {
  id: "en-BE",
  name: "English (Belgium)"
}, {
  id: "en-BZ",
  name: "English (Belize)"
}, {
  id: "en-BW",
  name: "English (Botswana)"
}, {
  id: "en-CA",
  name: "English (Canada)"
}, {
  id: "en-GU",
  name: "English (Guam)"
}, {
  id: "en-HK",
  name: "English (Hong Kong SAR China)"
}, {
  id: "en-IN",
  name: "English (India)"
}, {
  id: "en-IE",
  name: "English (Ireland)"
}, {
  id: "en-JM",
  name: "English (Jamaica)"
}, {
  id: "en-MT",
  name: "English (Malta)"
}, {
  id: "en-MH",
  name: "English (Marshall Islands)"
}, {
  id: "en-MU",
  name: "English (Mauritius)"
}, {
  id: "en-NA",
  name: "English (Namibia)"
}, {
  id: "en-NZ",
  name: "English (New Zealand)"
}, {
  id: "en-MP",
  name: "English (Northern Mariana Islands)"
}, {
  id: "en-PK",
  name: "English (Pakistan)"
}, {
  id: "en-PH",
  name: "English (Philippines)"
}, {
  id: "en-SG",
  name: "English (Singapore)"
}, {
  id: "en-ZA",
  name: "English (South Africa)"
}, {
  id: "en-TT",
  name: "English (Trinidad and Tobago)"
}, {
  id: "en-UM",
  name: "English (U.S. Minor Outlying Islands)"
}, {
  id: "en-VI",
  name: "English (U.S. Virgin Islands)"
}, {
  id: "en-GB",
  name: "English (United Kingdom)"
}, {
  id: "en-US",
  name: "English (United States)"
}, {
  id: "en-ZW",
  name: "English (Zimbabwe)"
}, {
  id: "en",
  name: "English"
}, {
  id: "eo",
  name: "Esperanto"
}, {
  id: "et-EE",
  name: "Estonian (Estonia)"
}, {
  id: "et",
  name: "Estonian"
}, {
  id: "ee-GH",
  name: "Ewe (Ghana)"
}, {
  id: "ee-TG",
  name: "Ewe (Togo)"
}, {
  id: "ee",
  name: "Ewe"
}, {
  id: "fo-FO",
  name: "Faroese (Faroe Islands)"
}, {
  id: "fo",
  name: "Faroese"
}, {
  id: "fil-PH",
  name: "Filipino (Philippines)"
}, {
  id: "fil",
  name: "Filipino"
}, {
  id: "fi-FI",
  name: "Finnish (Finland)"
}, {
  id: "fi",
  name: "Finnish"
}, {
  id: "fr-BE",
  name: "French (Belgium)"
}, {
  id: "fr-BJ",
  name: "French (Benin)"
}, {
  id: "fr-BF",
  name: "French (Burkina Faso)"
}, {
  id: "fr-BI",
  name: "French (Burundi)"
}, {
  id: "fr-CM",
  name: "French (Cameroon)"
}, {
  id: "fr-CA",
  name: "French (Canada)"
}, {
  id: "fr-CF",
  name: "French (Central African Republic)"
}, {
  id: "fr-TD",
  name: "French (Chad)"
}, {
  id: "fr-KM",
  name: "French (Comoros)"
}, {
  id: "fr-CG",
  name: "French (Congo - Brazzaville)"
}, {
  id: "fr-CD",
  name: "French (Congo - Kinshasa)"
}, {
  id: "fr-CI",
  name: "French (Côte d’Ivoire)"
}, {
  id: "fr-DJ",
  name: "French (Djibouti)"
}, {
  id: "fr-GQ",
  name: "French (Equatorial Guinea)"
}, {
  id: "fr-FR",
  name: "French (France)"
}, {
  id: "fr-GA",
  name: "French (Gabon)"
}, {
  id: "fr-GP",
  name: "French (Guadeloupe)"
}, {
  id: "fr-GN",
  name: "French (Guinea)"
}, {
  id: "fr-LU",
  name: "French (Luxembourg)"
}, {
  id: "fr-MG",
  name: "French (Madagascar)"
}, {
  id: "fr-ML",
  name: "French (Mali)"
}, {
  id: "fr-MQ",
  name: "French (Martinique)"
}, {
  id: "fr-MC",
  name: "French (Monaco)"
}, {
  id: "fr-NE",
  name: "French (Niger)"
}, {
  id: "fr-RW",
  name: "French (Rwanda)"
}, {
  id: "fr-RE",
  name: "French (Réunion)"
}, {
  id: "fr-BL",
  name: "French (Saint Barthélemy)"
}, {
  id: "fr-MF",
  name: "French (Saint Martin)"
}, {
  id: "fr-SN",
  name: "French (Senegal)"
}, {
  id: "fr-CH",
  name: "French (Switzerland)"
}, {
  id: "fr-TG",
  name: "French (Togo)"
}, {
  id: "fr",
  name: "French"
}, {
  id: "ff-SN",
  name: "Fulah (Senegal)"
}, {
  id: "ff",
  name: "Fulah"
}, {
  id: "gl-ES",
  name: "Galician (Spain)"
}, {
  id: "gl",
  name: "Galician"
}, {
  id: "lg-UG",
  name: "Ganda (Uganda)"
}, {
  id: "lg",
  name: "Ganda"
}, {
  id: "ka-GE",
  name: "Georgian (Georgia)"
}, {
  id: "ka",
  name: "Georgian"
}, {
  id: "de-AT",
  name: "German (Austria)"
}, {
  id: "de-BE",
  name: "German (Belgium)"
}, {
  id: "de-DE",
  name: "German (Germany)"
}, {
  id: "de-LI",
  name: "German (Liechtenstein)"
}, {
  id: "de-LU",
  name: "German (Luxembourg)"
}, {
  id: "de-CH",
  name: "German (Switzerland)"
}, {
  id: "de",
  name: "German"
}, {
  id: "el-CY",
  name: "Greek (Cyprus)"
}, {
  id: "el-GR",
  name: "Greek (Greece)"
}, {
  id: "el",
  name: "Greek"
}, {
  id: "gu-IN",
  name: "Gujarati (India)"
}, {
  id: "gu",
  name: "Gujarati"
}, {
  id: "guz-KE",
  name: "Gusii (Kenya)"
}, {
  id: "guz",
  name: "Gusii"
}, {
  id: "ha-Latn",
  name: "Hausa (Latin)"
}, {
  id: "ha-Latn-GH",
  name: "Hausa (Latin, Ghana)"
}, {
  id: "ha-Latn-NE",
  name: "Hausa (Latin, Niger)"
}, {
  id: "ha-Latn-NG",
  name: "Hausa (Latin, Nigeria)"
}, {
  id: "ha",
  name: "Hausa"
}, {
  id: "haw-US",
  name: "Hawaiian (United States)"
}, {
  id: "haw",
  name: "Hawaiian"
}, {
  id: "he-IL",
  name: "Hebrew (Israel)"
}, {
  id: "he",
  name: "Hebrew"
}, {
  id: "hi-IN",
  name: "Hindi (India)"
}, {
  id: "hi",
  name: "Hindi"
}, {
  id: "hu-HU",
  name: "Hungarian (Hungary)"
}, {
  id: "hu",
  name: "Hungarian"
}, {
  id: "is-IS",
  name: "Icelandic (Iceland)"
}, {
  id: "is",
  name: "Icelandic"
}, {
  id: "ig-NG",
  name: "Igbo (Nigeria)"
}, {
  id: "ig",
  name: "Igbo"
}, {
  id: "id-ID",
  name: "Indonesian (Indonesia)"
}, {
  id: "id",
  name: "Indonesian"
}, {
  id: "ga-IE",
  name: "Irish (Ireland)"
}, {
  id: "ga",
  name: "Irish"
}, {
  id: "it-IT",
  name: "Italian (Italy)"
}, {
  id: "it-CH",
  name: "Italian (Switzerland)"
}, {
  id: "it",
  name: "Italian"
}, {
  id: "ja-JP",
  name: "Japanese (Japan)"
}, {
  id: "ja",
  name: "Japanese"
}, {
  id: "kea-CV",
  name: "Kabuverdianu (Cape Verde)"
}, {
  id: "kea",
  name: "Kabuverdianu"
}, {
  id: "kab-DZ",
  name: "Kabyle (Algeria)"
}, {
  id: "kab",
  name: "Kabyle"
}, {
  id: "kl-GL",
  name: "Kalaallisut (Greenland)"
}, {
  id: "kl",
  name: "Kalaallisut"
}, {
  id: "kln-KE",
  name: "Kalenjin (Kenya)"
}, {
  id: "kln",
  name: "Kalenjin"
}, {
  id: "kam-KE",
  name: "Kamba (Kenya)"
}, {
  id: "kam",
  name: "Kamba"
}, {
  id: "kn-IN",
  name: "Kannada (India)"
}, {
  id: "kn",
  name: "Kannada"
}, {
  id: "kk-Cyrl",
  name: "Kazakh (Cyrillic)"
}, {
  id: "kk-Cyrl-KZ",
  name: "Kazakh (Cyrillic, Kazakhstan)"
}, {
  id: "kk",
  name: "Kazakh"
}, {
  id: "km-KH",
  name: "Khmer (Cambodia)"
}, {
  id: "km",
  name: "Khmer"
}, {
  id: "ki-KE",
  name: "Kikuyu (Kenya)"
}, {
  id: "ki",
  name: "Kikuyu"
}, {
  id: "rw-RW",
  name: "Kinyarwanda (Rwanda)"
}, {
  id: "rw",
  name: "Kinyarwanda"
}, {
  id: "kok-IN",
  name: "Konkani (India)"
}, {
  id: "kok",
  name: "Konkani"
}, {
  id: "ko-KR",
  name: "Korean (South Korea)"
}, {
  id: "ko",
  name: "Korean"
}, {
  id: "khq-ML",
  name: "Koyra Chiini (Mali)"
}, {
  id: "khq",
  name: "Koyra Chiini"
}, {
  id: "ses-ML",
  name: "Koyraboro Senni (Mali)"
}, {
  id: "ses",
  name: "Koyraboro Senni"
}, {
  id: "lag-TZ",
  name: "Langi (Tanzania)"
}, {
  id: "lag",
  name: "Langi"
}, {
  id: "lv-LV",
  name: "Latvian (Latvia)"
}, {
  id: "lv",
  name: "Latvian"
}, {
  id: "lt-LT",
  name: "Lithuanian (Lithuania)"
}, {
  id: "lt",
  name: "Lithuanian"
}, {
  id: "luo-KE",
  name: "Luo (Kenya)"
}, {
  id: "luo",
  name: "Luo"
}, {
  id: "luy-KE",
  name: "Luyia (Kenya)"
}, {
  id: "luy",
  name: "Luyia"
}, {
  id: "mk-MK",
  name: "Macedonian (Macedonia)"
}, {
  id: "mk",
  name: "Macedonian"
}, {
  id: "jmc-TZ",
  name: "Machame (Tanzania)"
}, {
  id: "jmc",
  name: "Machame"
}, {
  id: "kde-TZ",
  name: "Makonde (Tanzania)"
}, {
  id: "kde",
  name: "Makonde"
}, {
  id: "mg-MG",
  name: "Malagasy (Madagascar)"
}, {
  id: "mg",
  name: "Malagasy"
}, {
  id: "ms-BN",
  name: "Malay (Brunei)"
}, {
  id: "ms-MY",
  name: "Malay (Malaysia)"
}, {
  id: "ms",
  name: "Malay"
}, {
  id: "ml-IN",
  name: "Malayalam (India)"
}, {
  id: "ml",
  name: "Malayalam"
}, {
  id: "mt-MT",
  name: "Maltese (Malta)"
}, {
  id: "mt",
  name: "Maltese"
}, {
  id: "gv-GB",
  name: "Manx (United Kingdom)"
}, {
  id: "gv",
  name: "Manx"
}, {
  id: "mr-IN",
  name: "Marathi (India)"
}, {
  id: "mr",
  name: "Marathi"
}, {
  id: "mas-KE",
  name: "Masai (Kenya)"
}, {
  id: "mas-TZ",
  name: "Masai (Tanzania)"
}, {
  id: "mas",
  name: "Masai"
}, {
  id: "mer-KE",
  name: "Meru (Kenya)"
}, {
  id: "mer",
  name: "Meru"
}, {
  id: "mfe-MU",
  name: "Morisyen (Mauritius)"
}, {
  id: "mfe",
  name: "Morisyen"
}, {
  id: "naq-NA",
  name: "Nama (Namibia)"
}, {
  id: "naq",
  name: "Nama"
}, {
  id: "ne-IN",
  name: "Nepali (India)"
}, {
  id: "ne-NP",
  name: "Nepali (Nepal)"
}, {
  id: "ne",
  name: "Nepali"
}, {
  id: "nd-ZW",
  name: "North Ndebele (Zimbabwe)"
}, {
  id: "nd",
  name: "North Ndebele"
}, {
  id: "nb-NO",
  name: "Norwegian Bokmål (Norway)"
}, {
  id: "nb",
  name: "Norwegian Bokmål"
}, {
  id: "nn-NO",
  name: "Norwegian Nynorsk (Norway)"
}, {
  id: "nn",
  name: "Norwegian Nynorsk"
}, {
  id: "nyn-UG",
  name: "Nyankole (Uganda)"
}, {
  id: "nyn",
  name: "Nyankole"
}, {
  id: "or-IN",
  name: "Oriya (India)"
}, {
  id: "or",
  name: "Oriya"
}, {
  id: "om-ET",
  name: "Oromo (Ethiopia)"
}, {
  id: "om-KE",
  name: "Oromo (Kenya)"
}, {
  id: "om",
  name: "Oromo"
}, {
  id: "ps-AF",
  name: "Pashto (Afghanistan)"
}, {
  id: "ps",
  name: "Pashto"
}, {
  id: "fa-AF",
  name: "Persian (Afghanistan)"
}, {
  id: "fa-IR",
  name: "Persian (Iran)"
}, {
  id: "fa",
  name: "Persian"
}, {
  id: "pl-PL",
  name: "Polish (Poland)"
}, {
  id: "pl",
  name: "Polish"
}, {
  id: "pt-BR",
  name: "Portuguese (Brazil)"
}, {
  id: "pt-GW",
  name: "Portuguese (Guinea-Bissau)"
}, {
  id: "pt-MZ",
  name: "Portuguese (Mozambique)"
}, {
  id: "pt-PT",
  name: "Portuguese (Portugal)"
}, {
  id: "pt",
  name: "Portuguese"
}, {
  id: "pa-Arab",
  name: "Punjabi (Arabic)"
}, {
  id: "pa-Arab-PK",
  name: "Punjabi (Arabic, Pakistan)"
}, {
  id: "pa-Guru",
  name: "Punjabi (Gurmukhi)"
}, {
  id: "pa-Guru-IN",
  name: "Punjabi (Gurmukhi, India)"
}, {
  id: "pa",
  name: "Punjabi"
}, {
  id: "ro-MD",
  name: "Romanian (Moldova)"
}, {
  id: "ro-RO",
  name: "Romanian (Romania)"
}, {
  id: "ro",
  name: "Romanian"
}, {
  id: "rm-CH",
  name: "Romansh (Switzerland)"
}, {
  id: "rm",
  name: "Romansh"
}, {
  id: "rof-TZ",
  name: "Rombo (Tanzania)"
}, {
  id: "rof",
  name: "Rombo"
}, {
  id: "ru-MD",
  name: "Russian (Moldova)"
}, {
  id: "ru-RU",
  name: "Russian (Russia)"
}, {
  id: "ru-UA",
  name: "Russian (Ukraine)"
}, {
  id: "ru",
  name: "Russian"
}, {
  id: "rwk-TZ",
  name: "Rwa (Tanzania)"
}, {
  id: "rwk",
  name: "Rwa"
}, {
  id: "saq-KE",
  name: "Samburu (Kenya)"
}, {
  id: "saq",
  name: "Samburu"
}, {
  id: "sg-CF",
  name: "Sango (Central African Republic)"
}, {
  id: "sg",
  name: "Sango"
}, {
  id: "seh-MZ",
  name: "Sena (Mozambique)"
}, {
  id: "seh",
  name: "Sena"
}, {
  id: "sr-Cyrl",
  name: "Serbian (Cyrillic)"
}, {
  id: "sr-Cyrl-BA",
  name: "Serbian (Cyrillic, Bosnia and Herzegovina)"
}, {
  id: "sr-Cyrl-ME",
  name: "Serbian (Cyrillic, Montenegro)"
}, {
  id: "sr-Cyrl-RS",
  name: "Serbian (Cyrillic, Serbia)"
}, {
  id: "sr-Latn",
  name: "Serbian (Latin)"
}, {
  id: "sr-Latn-BA",
  name: "Serbian (Latin, Bosnia and Herzegovina)"
}, {
  id: "sr-Latn-ME",
  name: "Serbian (Latin, Montenegro)"
}, {
  id: "sr-Latn-RS",
  name: "Serbian (Latin, Serbia)"
}, {
  id: "sr",
  name: "Serbian"
}, {
  id: "sn-ZW",
  name: "Shona (Zimbabwe)"
}, {
  id: "sn",
  name: "Shona"
}, {
  id: "ii-CN",
  name: "Sichuan Yi (China)"
}, {
  id: "ii",
  name: "Sichuan Yi"
}, {
  id: "si-LK",
  name: "Sinhala (Sri Lanka)"
}, {
  id: "si",
  name: "Sinhala"
}, {
  id: "sk-SK",
  name: "Slovak (Slovakia)"
}, {
  id: "sk",
  name: "Slovak"
}, {
  id: "sl-SI",
  name: "Slovenian (Slovenia)"
}, {
  id: "sl",
  name: "Slovenian"
}, {
  id: "xog-UG",
  name: "Soga (Uganda)"
}, {
  id: "xog",
  name: "Soga"
}, {
  id: "so-DJ",
  name: "Somali (Djibouti)"
}, {
  id: "so-ET",
  name: "Somali (Ethiopia)"
}, {
  id: "so-KE",
  name: "Somali (Kenya)"
}, {
  id: "so-SO",
  name: "Somali (Somalia)"
}, {
  id: "so",
  name: "Somali"
}, {
  id: "es-AR",
  name: "Spanish (Argentina)"
}, {
  id: "es-BO",
  name: "Spanish (Bolivia)"
}, {
  id: "es-CL",
  name: "Spanish (Chile)"
}, {
  id: "es-CO",
  name: "Spanish (Colombia)"
}, {
  id: "es-CR",
  name: "Spanish (Costa Rica)"
}, {
  id: "es-DO",
  name: "Spanish (Dominican Republic)"
}, {
  id: "es-EC",
  name: "Spanish (Ecuador)"
}, {
  id: "es-SV",
  name: "Spanish (El Salvador)"
}, {
  id: "es-GQ",
  name: "Spanish (Equatorial Guinea)"
}, {
  id: "es-GT",
  name: "Spanish (Guatemala)"
}, {
  id: "es-HN",
  name: "Spanish (Honduras)"
}, {
  id: "es-419",
  name: "Spanish (Latin America)"
}, {
  id: "es-MX",
  name: "Spanish (Mexico)"
}, {
  id: "es-NI",
  name: "Spanish (Nicaragua)"
}, {
  id: "es-PA",
  name: "Spanish (Panama)"
}, {
  id: "es-PY",
  name: "Spanish (Paraguay)"
}, {
  id: "es-PE",
  name: "Spanish (Peru)"
}, {
  id: "es-PR",
  name: "Spanish (Puerto Rico)"
}, {
  id: "es-ES",
  name: "Spanish (Spain)"
}, {
  id: "es-US",
  name: "Spanish (United States)"
}, {
  id: "es-UY",
  name: "Spanish (Uruguay)"
}, {
  id: "es-VE",
  name: "Spanish (Venezuela)"
}, {
  id: "es",
  name: "Spanish"
}, {
  id: "sw-KE",
  name: "Swahili (Kenya)"
}, {
  id: "sw-TZ",
  name: "Swahili (Tanzania)"
}, {
  id: "sw",
  name: "Swahili"
}, {
  id: "sv-FI",
  name: "Swedish (Finland)"
}, {
  id: "sv-SE",
  name: "Swedish (Sweden)"
}, {
  id: "sv",
  name: "Swedish"
}, {
  id: "gsw-CH",
  name: "Swiss German (Switzerland)"
}, {
  id: "gsw",
  name: "Swiss German"
}, {
  id: "shi-Latn",
  name: "Tachelhit (Latin)"
}, {
  id: "shi-Latn-MA",
  name: "Tachelhit (Latin, Morocco)"
}, {
  id: "shi-Tfng",
  name: "Tachelhit (Tifinagh)"
}, {
  id: "shi-Tfng-MA",
  name: "Tachelhit (Tifinagh, Morocco)"
}, {
  id: "shi",
  name: "Tachelhit"
}, {
  id: "dav-KE",
  name: "Taita (Kenya)"
}, {
  id: "dav",
  name: "Taita"
}, {
  id: "ta-IN",
  name: "Tamil (India)"
}, {
  id: "ta-LK",
  name: "Tamil (Sri Lanka)"
}, {
  id: "ta",
  name: "Tamil"
}, {
  id: "te-IN",
  name: "Telugu (India)"
}, {
  id: "te",
  name: "Telugu"
}, {
  id: "teo-KE",
  name: "Teso (Kenya)"
}, {
  id: "teo-UG",
  name: "Teso (Uganda)"
}, {
  id: "teo",
  name: "Teso"
}, {
  id: "th-TH",
  name: "Thai (Thailand)"
}, {
  id: "th",
  name: "Thai"
}, {
  id: "bo-CN",
  name: "Tibetan (China)"
}, {
  id: "bo-IN",
  name: "Tibetan (India)"
}, {
  id: "bo",
  name: "Tibetan"
}, {
  id: "ti-ER",
  name: "Tigrinya (Eritrea)"
}, {
  id: "ti-ET",
  name: "Tigrinya (Ethiopia)"
}, {
  id: "ti",
  name: "Tigrinya"
}, {
  id: "to-TO",
  name: "Tonga (Tonga)"
}, {
  id: "to",
  name: "Tonga"
}, {
  id: "tr-TR",
  name: "Turkish (Turkey)"
}, {
  id: "tr",
  name: "Turkish"
}, {
  id: "uk-UA",
  name: "Ukrainian (Ukraine)"
}, {
  id: "uk",
  name: "Ukrainian"
}, {
  id: "ur-IN",
  name: "Urdu (India)"
}, {
  id: "ur-PK",
  name: "Urdu (Pakistan)"
}, {
  id: "ur",
  name: "Urdu"
}, {
  id: "uz-Arab",
  name: "Uzbek (Arabic)"
}, {
  id: "uz-Arab-AF",
  name: "Uzbek (Arabic, Afghanistan)"
}, {
  id: "uz-Cyrl",
  name: "Uzbek (Cyrillic)"
}, {
  id: "uz-Cyrl-UZ",
  name: "Uzbek (Cyrillic, Uzbekistan)"
}, {
  id: "uz-Latn",
  name: "Uzbek (Latin)"
}, {
  id: "uz-Latn-UZ",
  name: "Uzbek (Latin, Uzbekistan)"
}, {
  id: "uz",
  name: "Uzbek"
}, {
  id: "vi-VN",
  name: "Vietnamese (Vietnam)"
}, {
  id: "vi",
  name: "Vietnamese"
}, {
  id: "vun-TZ",
  name: "Vunjo (Tanzania)"
}, {
  id: "vun",
  name: "Vunjo"
}, {
  id: "cy-GB",
  name: "Welsh (United Kingdom)"
}, {
  id: "cy",
  name: "Welsh"
}, {
  id: "yo-NG",
  name: "Yoruba (Nigeria)"
}, {
  id: "yo",
  name: "Yoruba"
}, {
  id: "zu-ZA",
  name: "Zulu (South Africa)"
}, {
  id: "zu",
  name: "Zulu"
}];